@if (form && rows) {
  <section>
    <zbp-data-table
      [theme]="tableTheme"
      [columns]="columns"
      [rows]="rows"
      [isLoading]="!licensesLoaded"
      [formArray]="licensesFormArray"
      [noResultsMessage]="getNoResultsMessage()"
    ></zbp-data-table>
  </section>
}
